import { TZDate } from '@date-fns/tz';
import { isWeekend, subDays, subHours } from 'date-fns';
const subBusinessDays = (date, amount) => {
    if (amount <= 0) {
        return date;
    }
    const previousDay = subDays(date, 1);
    return subBusinessDays(previousDay, isWeekend(previousDay) ? amount : amount - 1);
};
const SUBTRACT_BY_UNIT = {
    business_days: (date, amount) => subBusinessDays(date, amount),
    days: (date, amount) => subDays(date, amount),
    hours: (date, amount) => subHours(date, amount),
};
/**
 * Days are counted on the calendar of the given timezone, so the deadline keeps the meeting's
 * wall-clock time across DST transitions and business days skip the local Saturday and Sunday.
 */
export const calculateAgendaPublishDeadline = ({ meetingDate, unit, amount, timezone, }) => {
    const zonedMeetingDate = new TZDate(new Date(meetingDate), timezone);
    return new Date(SUBTRACT_BY_UNIT[unit](zonedMeetingDate, amount));
};
